import { Typography } from 'antd'

const NotGuaranteed: React.FC = () => (
  <Typography.Text>
    While estimates are not guaranteed, please reach out to the primary CIMS
    contact if a request is taking far longer than expected.
  </Typography.Text>
)

export default NotGuaranteed
